import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { IconShareAlt, Skeleton, useToast } from '@machobear/design-system'
import { copyText } from '@/utils/copy-to-clipboard'
import Icon from '@/components/icon'
import { useListingActions } from '../context/listing-actions'
import { useListingData } from '../context/listing-data'
import { useListingDashboardModals } from '../modals'

const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: solid 1px #d2d7df;
  border-radius: 4px;
`

const Input = styled.input`
  min-width: 100px;
  flex-grow: 1;
  flex-shrink: 1;
  font-size: 14px;
  font-weight: 500;
  background: white;
  color: #4964e9;
  border-width: 0;
  height: 40px;
  padding: 0;
`

const IconSpace = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 4px;
`

const InlineButton = styled.button`
  flex-shrink: 0;
  height: 40px;
  width: 40px;
  display: flex;
  padding: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f6fc;
  border-color: #d2d7df;
  border-left-width: 1px;
  border-right-width: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  cursor: pointer;

  &:hover {
    background-color: #dce5f2;
  }
`

export const PublicLinkField = () => {
  const { t } = useTranslation()
  const showToast = useToast()
  const { publicLink, goToPublicLink } = useListingActions()
  const { showModal } = useListingDashboardModals()
  const { loading } = useListingData()

  const copyToClipboard = async () => {
    await copyText(publicLink)
    showToast({
      message: t(
        'l.listing.share_copy.toast_success.text',
        'The listing link has been copied to your clipboard!'
      ),
      tone: 'positive'
    })
  }

  const share = showModal('mainDialog')

  if (loading) return <Skeleton.Button />

  return (
    <Field>
      <IconSpace>
        <Icon id="link" style={{ height: '16px', width: '16px', flexShrink: 0 }} />
      </IconSpace>

      <Input
        readOnly
        value={publicLink}
        onClick={goToPublicLink}
        aria-label="Public Link"
        style={{ cursor: 'pointer' }}
      />

      <InlineButton onClick={copyToClipboard}>
        <Icon id="copy" style={{ height: '16px', width: '16px' }} />
      </InlineButton>
      <InlineButton
        onClick={share}
        style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px' }}
      >
        <IconShareAlt size="small" />
      </InlineButton>
    </Field>
  )
}
